module.exports = __webpack_public_path__ + "40c47ccc5f8c7d2c334d983f199efce3.png";